/// <reference path="./types.js" />

/**
 * Seleciona o estado de RDMs do estado global da store.
 * @param {any} state - Estado global da store Redux.
 * @returns {RdmState}
 */
export const getRdmState = (state) => state.rdms;
